import React from "react";
import { Switch, Route, Redirect, Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import qs from "query-string";
import { DemoAdditionalInfo } from "@/pages/demo/additionalInfo";
import { PARAM_TO_VIEW_MAP } from "@/pages/demo/constants/views";
import { DemoAdditionalInfoTwoSteps } from "../pages/demo/additionalInfoTwoSteps";
import { DemoFormVersion } from "../constants/demoFormVersions";
import { VERSION_MAP, DEMO_FORM_VERSION_QUERY_PARAM } from "../hooks/useDemoFormVersion";

export const DEMO_ADDITIONAL_INFO_BASE_ROUTE = "/demo/additional-info";
export const DEMO_SCHEDULE_ROUTE = "/demo/schedule";

const history = createBrowserHistory();

const isValidStepId = (stepId: string): boolean => {
  const allowedStepIds = Object.keys(PARAM_TO_VIEW_MAP);
  return allowedStepIds.includes(stepId);
};

const getDemoFormVersionFromSearch = (search: string): DemoFormVersion => {
  const queryParams = qs.parse(search);
  const demoFormVersion = queryParams[DEMO_FORM_VERSION_QUERY_PARAM] as string;
  return VERSION_MAP[demoFormVersion] || DemoFormVersion.DEFAULT;
};

const renderAdditionalInfoRoute = (stepId: string, demoFormVersion: DemoFormVersion) => {
  if (!isValidStepId(stepId)) {
    return <Redirect to={`${DEMO_ADDITIONAL_INFO_BASE_ROUTE}/personal-info`} />;
  }

  const isTwoStepsDemoForm = demoFormVersion === DemoFormVersion.VERSION_08252;
  return isTwoStepsDemoForm ? <DemoAdditionalInfoTwoSteps /> : <DemoAdditionalInfo />;
};

const renderScheduleRoute = (demoFormVersion: DemoFormVersion) => {
  const isTwoStepsDemoForm = demoFormVersion === DemoFormVersion.VERSION_08252;
  return isTwoStepsDemoForm ? <DemoAdditionalInfoTwoSteps /> : <DemoAdditionalInfo />;
};

export function AppRouter() {
  return (
    <Router history={history}>
      <div className="h-dvh w-full overflow-hidden">
        <Switch>
          <Route
            path={`${DEMO_ADDITIONAL_INFO_BASE_ROUTE}/:stepId`}
            render={({ match, location }) => {
              const { stepId } = match.params;
              const demoFormVersion = getDemoFormVersionFromSearch(location.search);
              return renderAdditionalInfoRoute(stepId, demoFormVersion);
            }}
          />
          <Route
            exact
            path={DEMO_ADDITIONAL_INFO_BASE_ROUTE}
            render={({ location }) => {
              const demoFormVersion = getDemoFormVersionFromSearch(location.search);
              return renderScheduleRoute(demoFormVersion);
            }}
          />
          <Route
            exact
            path={DEMO_SCHEDULE_ROUTE}
            render={({ location }) => {
              const demoFormVersion = getDemoFormVersionFromSearch(location.search);
              return renderScheduleRoute(demoFormVersion);
            }}
          />
          <Redirect to={`${DEMO_ADDITIONAL_INFO_BASE_ROUTE}/personal-info`} />
        </Switch>
      </div>
    </Router>
  );
}
